import React, {useState} from 'react'
import { Formik, Form } from "formik";
import TextField from "../../my_account/text_field";
import Checkbox from "../../my_account/checkbox";
import ReturnsPrintInStoreSwitch from './returns_print_in_store_switch';
import ReturnsUnlabelledSwitch from './returns_unlabelled_switch';
import YodelDropdown from '../../my_account/yodel_dropdown';
import RegularExpressions from '../../utils/regular-expressions';

export default function ReturnsForm({
  currentUser,
  retailer,
  isPrintInStore,
  isUnlabelledLocker,
  useInPostRetailerPageNewCopy,
  useInPostReturnsRemoveMarketingCheckbox,
  csReturn,
  totalInPounds,
  returnAttributes,
  casualUserAttributes,
  error,
  createNewLabel,
  setPrintInStore,
  setUnlabelledLocker,
  showPrePayment,
  isStoreComponents,
  isLockersComponents,
  setIsStoreComponents,
  setIsLockersComponents,
  setRetailerIntroduction,
  setRetailerDimensions,
  setPreFormContent,
  setPostFormContent,
}){
  const [showFreeFormReasonCode, setShowFreeFormReasonCode] = useState(false);
  const showMarketingOptIn = !currentUser || !currentUser?.marketingOptIn;

  let formInitialValues = {
    firstname: currentUser?.firstname || casualUserAttributes?.firstname || "",
    surname: currentUser?.surname || casualUserAttributes?.surname || "",
    email: currentUser?.email || casualUserAttributes?.email || "",
    mobile: currentUser?.mobile || casualUserAttributes?.mobile || "",
    marketingOptIn: currentUser?.marketingOptIn || casualUserAttributes?.marketingOptIn || false,
  }

  if (retailer.useRetailerReference) {
    formInitialValues.retailerReference = returnAttributes?.retailerReference || "";
  }

  if (retailer.useReturnReference || retailer.useFreeFormReasonCode) {
    formInitialValues.returnReference = returnAttributes?.returnReference || "";
  }

  if (retailer.useReasonCodes) {
    formInitialValues.reasonCode = "";
  }

  if (csReturn) {
    formInitialValues.csUser = returnAttributes?.csUser || "";
    formInitialValues.password = returnAttributes?.password || "";
  } else {
    formInitialValues.yodelTermsOfService = false;
  }

  const handleSubmit = async (values, actions) => {
    let returnAttrs = {
      retailerId: retailer.id,
    }
    if (retailer.useRetailerReference) {
      returnAttrs.retailerReference = (values.retailerReference?.length > 0 || retailer.requireRetailerReference) ? values.retailerReference : null;
    }
    if (retailer.useReturnReference) {
      returnAttrs.returnReference = values.returnReference?.length > 0 || retailer.requireReturnReference ? values.returnReference : null;
    }
    if (isPrintInStore && isStoreComponents) {
      returnAttrs.printInStore = isPrintInStore;
    }
    
    if (isLockersComponents) {
      returnAttrs.isInpostLocker = true;
      returnAttrs.unlabelledInpostLocker = isUnlabelledLocker;
    }
    if (retailer.useReasonCodes) {
      returnAttrs.reasonCodeId = values.reasonCode.id;
      if (checkFreeFormReasonCode(values.reasonCode.id)) {
        returnAttrs.returnReference = values.returnReference;
      }
    }

    if (csReturn) {
      returnAttrs.csGenerated = true;
      returnAttrs.csUser = values.csUser;
      returnAttrs.password = values.password;
    }

    let casualUserAttrs;
    casualUserAttrs = {
      firstname: values.firstname,
      surname: values.surname,
      email: values.email,
      marketingOptIn: values.marketingOptIn,
      termsOfService: true,
      yodelTermsOfService: true
    };

    if (RegularExpressions.mobile.test(values.mobile)) {
      casualUserAttrs["mobile"] = values.mobile;
    }

    let totalPrice = retailer.price + (isPrintInStore ? (retailer.printInStorePrice || 0) : 0);

    if (totalPrice > 0 && isStoreComponents && !isLockersComponents && !csReturn) {
      showPrePayment(returnAttrs, casualUserAttrs, totalPrice)
    } else {
      createNewLabel(returnAttrs, casualUserAttrs, totalPrice);
    }

  }

  const checkFreeFormReasonCode = (reasonCodeId) => {
    return retailer.useFreeFormReasonCode &&
      retailer.reasonCodes[retailer.reasonCodes.length - 1].id === reasonCodeId;
  }

  const validate = (values) => {
    const errors = {};

    if (("retailerReference" in values)) {
      if (!values.retailerReference && retailer.requireRetailerReference) {
        errors.retailerReference = "Can't be blank";
      } else if (retailer.retailerReferenceMinLength && (values.retailerReference.length < retailer.retailerReferenceMinLength)) {
        errors.retailerReference = `Can't be shorter than ${retailer.retailerReferenceMinLength} characters`;
      } else if (retailer.retailerReferenceMaxLength && (values.retailerReference.length > retailer.retailerReferenceMaxLength)) {
        errors.retailerReference = `Can't be longer than ${retailer.retailerReferenceMaxLength} characters`
      }
    }

    if (("returnReference" in values)) {
      if (!values.returnReference && retailer.requireReturnReference) {
        errors.returnReference = "Can't be blank";
      } else if (retailer.returnReferenceMinLength && (values.returnReference.length < retailer.returnReferenceMinLength)) {
        errors.returnReference = `Can't be shorter than ${retailer.returnReferenceMinLength} characters`;
      } else if (retailer.returnReferenceMaxLength && (values.returnReference.length > retailer.returnReferenceMaxLength)) {
        errors.returnReference = `Can't be longer than ${retailer.returnReferenceMaxLength} characters`
      }
    }

    if ("reasonCode" in values) {
      let evaluateFreeFormReasonCode = false;
      if (!values.reasonCode) {
        errors.reasonCode = "Please select a reason"
      } else if(checkFreeFormReasonCode(values.reasonCode.id)) {
        setShowFreeFormReasonCode(true);
        evaluateFreeFormReasonCode = true;
      }else {
        setShowFreeFormReasonCode(false);
      }

      if (evaluateFreeFormReasonCode && !values.returnReference) {
        errors.returnReference = "Can't be blank";
      }
    }

    if (!values.email) {
      errors.email = 'Please enter an email address';
    } else if (!RegularExpressions.email.test(values.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (isLockersComponents) {
      if (!values.firstname) {
        errors.firstname = 'Please enter your first name';
      }

      if (!values.surname) {
        errors.surname = 'Please enter your last name';
      }

      if (!values.mobile) {
        errors.mobile = 'Please enter a valid mobile number';
      } else if (!RegularExpressions.mobile.test(values.mobile)) {
        errors.mobile = 'Please enter a valid mobile number';
      }
    }

    if (csReturn) {
      if (!values.csUser) {
        errors.csUser = 'Please enter an email address';
      } else if (!RegularExpressions.email.test(values.csUser)) {
        errors.csUser = 'Please enter a valid email address';
      }

      if (!values.password) {
        errors.password = 'Please enter a password';
      }
    } else {
      if (!values.yodelTermsOfService) {
        errors.yodelTermsOfService =
          'Please accept terms and conditions to proceed';
      }
    }
  
    return errors;
  };

  const createLabelFormSubmitText = () => {
    if (csReturn) {
      return "Proceed";

    } else if (isStoreComponents) {

      if (totalInPounds === 0) {
        return isPrintInStore ? "View barcode" : "Email me my new label";
      } else {
        return "Review & Pay";
      }

    } else if (isLockersComponents) {
      return isUnlabelledLocker ? "Email my locker code" : "Email me my new label";
    }
  };

  let storesHeaderCopy;
  if (useInPostRetailerPageNewCopy) {
    if (isPrintInStore) {
      storesHeaderCopy = `Complete the fields below and take your barcode to the InPost Shop, where it will be printed for you by the shopkeeper.` +
                         `${retailer?.enablePrintAtHome ? " Alternatively, choose Print at Home and create your label, attach it to your parcel and head to your chosen InPost Shop." : ""}`
    }else {
      storesHeaderCopy = `Complete the fields below and create your label. Print it out, attach it to your parcel, and head to your chosen InPost Shop.` +
                         `${retailer?.enablePrintInStore ? " Alternatively, choose Print at Shop and take your barcode to the InPost Shop where it will be printed for you by the shopkeeper." : ""}`
    }
  } else {
    storesHeaderCopy = `Complete the fields below and we will send ${
      isPrintInStore
        ? `a link to download ${csReturn ? "the customer" : "your"} barcode. Just head to your chosen Yodel Store and the storekeeper will print your label.`
        : `you ${csReturn ? "a link to download the customer" : "your"} label. Simply print it out, attach to your item, and head to your chosen Yodel Store.`
    }`;
  }

  const lockersHeaderCopy = `Complete the fields below and we will send ${
                              isUnlabelledLocker
                              ? `a link to download ${csReturn ? "the customer" : "your"} code. Just head to your chosen InPost Locker and scan your code to access it.`
                              : `you ${csReturn ? "the customer" : "your"} label. Print the label, attach it to your parcel and head to your chosen InPost Locker.`
                            }`;

  return (
    <div>
      {useInPostRetailerPageNewCopy && (
        <p>
          You may have seen this service previously as Yodel Store Returns, now it's InPost Shop Returns. Same way of
          returning parcels, just a new name. <b>
            With this service, you can only return your parcels to an InPost Shop, and not in an InPost Locker.
          </b>
        </p>
      )}

      {isStoreComponents && (
        <>
          <p>{storesHeaderCopy}</p>
          {useInPostRetailerPageNewCopy && (
            <>
              <p>Step 1: Create the label by completing the fields below</p>
              <p>Step 2: Find your most convenient InPost Shop to return your order</p>
            </>
          )}
        </>
      )}

      {isLockersComponents && (
        <p>{lockersHeaderCopy}</p>
      )}

      <Formik
        initialValues={formInitialValues}
        validate={validate}
        onSubmit={handleSubmit}>
        {({ isSubmitting, errors, isValid }) => (
          <Form className="new_user" noValidate>
            {isStoreComponents &&
              <ReturnsPrintInStoreSwitch
                retailer={retailer}
                printingPrice={csReturn ? 0 : retailer.printInStorePrice}
                printInStoreValue={isPrintInStore}
                setPrintInStore={setPrintInStore}
                useInPostRetailerPageNewCopy={useInPostRetailerPageNewCopy}
              />
            }

            {!csReturn && isLockersComponents &&
              <ReturnsUnlabelledSwitch
                retailer={retailer}
                printingPrice={retailer.printInStorePrice}
                unlabelledLockerValue={isUnlabelledLocker}
                setUnlabelledLocker={setUnlabelledLocker} />
            }
            
            {error &&
              <div className="yodel-returns-error-message">
                <img src="/assets/yodel-assets/warning-triangle.svg" alt="error icon" />
                {error}
              </div>
            }

            {retailer.useRetailerReference &&
              <TextField label={retailer.retailerReferenceLabel || 'Order number'} name="retailerReference" type="text" showValidMarker={false} />
            }

            {retailer.useReturnReference &&
              <TextField label={retailer.returnReferenceLabel} name="returnReference" type="text" showValidMarker={false} />
            }

            {retailer.useReasonCodes &&
              <>
                <div className="yodel-returns-dropdown-container">
                  <YodelDropdown
                    options={retailer.reasonCodes}
                    labelField="reason"
                    valueField="id"
                    clearInput={false}
                    id="reasonCode"
                    name="reasonCode"
                    unselectedLabel={retailer.reasonCodeLabel || "Return Reason"}
                    allowErrorStyle={true}
                    isMobile={true}
                  />
                </div>
                {showFreeFormReasonCode &&
                  <TextField label={retailer.returnReferenceLabel} name="returnReference" type="text" showValidMarker={false} />
                }
              </>
            }

            {isLockersComponents &&
              <>
                <TextField
                  label={"Your first name"}
                  name="firstname"
                  type="text"
                  showValidMarker={false}
                  readOnly={currentUser?.firstname ? true : false}
                />
                <TextField
                  label={"Your last name"}
                  name="surname"
                  type="text"
                  showValidMarker={false}
                  readOnly={currentUser?.surname ? true : false}
                />
              </>
            }

            <TextField label={csReturn ? "Customer's email address" : "Your email"} name="email" type="text" showValidMarker={false} readOnly={currentUser?.email ? true : false} />

            {isLockersComponents &&
              <TextField
                label={"Your mobile number"}
                name="mobile"
                type="text"
                showValidMarker={false}
                readOnly={currentUser?.mobile ? true : false}
              />
            }

            {csReturn ?
              <>
                <TextField label={"Your email address"} name="csUser" type="text" showValidMarker={false} />
                <TextField label={"Password"} name="password" type="text" showValidMarker={false} />
              </>
              :
              <div className="retailer__new-label-form-checkboxes">
                {!useInPostReturnsRemoveMarketingCheckbox && showMarketingOptIn &&
                  <Checkbox name="marketingOptIn" id="marketingOptIn" >
                    Email me the latest news & special offers.
                  </Checkbox>
                }

                <Checkbox name="yodelTermsOfService" id="yodelTermsOfService" >
                  <span>
                    {"I accept InPost "}
                    <a title="Terms of Service" target="_blank" href="/terms-and-conditions">Terms &amp; Conditions</a>
                    {" and "}
                    <a title="Privacy Policy" target="_blank" href="/privacy-cookies-policy">Privacy Policy</a>
                    .
                  </span>
                </Checkbox>
              </div>
            }

            <input
              type="submit"
              name="submit"
              value={createLabelFormSubmitText()}
              className="yodel-outline-button returns-form-botton"
              disabled={isSubmitting}
            />
          </Form>
        )}
      </Formik>

      {!csReturn && (retailer?.enablePrintAtHome || retailer?.enablePrintInStore) && (retailer?.unlabelledInpostLockers || retailer?.labelledInpostLockers) && (
        <>
          <div className="retailer__choose-option-buttons">
            <p className="retailer__choose-method">{ "Want to return using a different method?" }</p>
            {isStoreComponents && (
              <div className="retailer__choose-method-options">
                <button
                  type="button"
                  className="yodel-outline-button returns-form-botton -secondary-style"
                  onClick={() => {
                    setIsStoreComponents(false);
                    setIsLockersComponents(true);
                    setRetailerIntroduction(retailer?.lockersIntroduction);
                    setRetailerDimensions(retailer?.lockersDimensionsAndPinsOverrideContent);
                    setPreFormContent(retailer?.lockersPreFormContent);
                    setPostFormContent(retailer?.lockersPostFormContent);
                  }}
                >
                  Return to InPost Locker
                </button>
              </div>
            )}

            {isLockersComponents && (
              <div className="retailer__choose-method-options">
                <button
                  type="button"
                  className="yodel-outline-button returns-form-botton -secondary-style"
                  onClick={() => {
                    setIsStoreComponents(true);
                    setIsLockersComponents(false);
                    setRetailerIntroduction(retailer?.storesIntroduction);
                    setRetailerDimensions(retailer?.storesDimensionsAndPinsOverrideContent);
                    setPreFormContent(retailer?.storesPreFormContent);
                    setPostFormContent(retailer?.storesPostFormContent);
                  }}
                >
                  Return to Yodel Store
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}
